import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface RestaurantData {
  id: string;
  accountId: string;
  name: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  contactInfo: {
    name: string;
    email: string;
    phone: string;
  };
  location: {
    address: string;
    city: string;
    state: string;
    country: string;
    zipcode: string;
    coordinates: {
      lat: number;
      lng: number;
    };
  };
  workingHours: {
    [key: string]: {
      firstHalf: {
        start: string;
        end: string;
      };
      secondHalf: {
        start: string;
        end: string;
      };
      isClosed: boolean;
    };
  };
  settings: {
    cuisineTypes: string[];
    posType: string;
    serviceTypes: string[];
  };
  restaurantDetails: {
    website: string;
    images: Array<{
      url: string;
      type: string;
    }>;
    rating: number;
    totalReviews: number;
    timeZone: string;
    currency: string;
  };
  isActive: boolean;
  domain: {
    web: string;
    dining: string;
  };
  parentRestaurantId: string;
}

interface RestaurantState {
  data: RestaurantData | null;
  loading: boolean;
  error: string | null;
}

const initialState: RestaurantState = {
  data: null,
  loading: false,
  error: null,
};

const restaurantSlice = createSlice({
  name: 'restaurant',
  initialState,
  reducers: {
    fetchRestaurantRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchRestaurantSuccess: (state, action: PayloadAction<RestaurantData>) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    fetchRestaurantFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchRestaurantRequest,
  fetchRestaurantSuccess,
  fetchRestaurantFailure,
} = restaurantSlice.actions;

export default restaurantSlice.reducer;
